module.exports = __webpack_public_path__ + "static/img/slide_6_fr.0791a0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_6_fr.png
// module id = xEBQ
// module chunks = 0